<!--
 * @Description: 上传发票-人-上传、查看
 * @Date: 2025-07-03 17:42:46
-->

<template>
  <BaseDialog
    width="680px"
    class="form-dialog form-dialog--label120"
    title="上传发票"
    :model-value="true"
    :show-close="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
    :showFooter="false"
  >
    <BaseTextContent>
      <BaseForm
        ref="formRef"
        label-position="right"
        :model="formData"
        :rules="formRules"
      >
        <div class="form-dialog__title">
          <h1>发票</h1>
        </div>
        <div class="form-dialog__content" style="display: block">
          <BaseFormItem label="发票照片" prop="list">
            <div>
              <BaseUpload
                v-if="!disabled"
                style="margin-bottom: 20px"
                autoUpload
                btnText="上传"
                tipText="只能上传jpg/png，且每份不超过50MB"
                :listType="null"
                :accept="['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG']"
                :limit="20"
                :limitSize="50"
                :multiple="false"
                :showFileList="false"
                :http-request="uploadApi"
              ></BaseUpload>
              <div
                style="
                  position: relative;
                  display: flex;
                  align-items: flex-end;
                  margin-bottom: 30px;
                "
                v-for="img in formData.list"
                :key="img.invoicePic"
              >
                <BaseImage
                  style="width: 200px; height: 120px"
                  :src="img.invoicePic"
                  :preview-src-list="[img.invoicePic]"
                />

                <div style="margin-left: 20px">
                  <span>发票号码</span>
                  <BaseInput
                    style="width: 240px"
                    :disabled="disabled"
                    v-model="img.invoiceNo"
                  />
                </div>
                <BaseIcon
                  v-if="!disabled"
                  size="18"
                  color="#ED7067"
                  style="
                    cursor: pointer;
                    position: absolute;
                    right: -35px;
                    bottom: 10px;
                  "
                >
                  <DeleteFilled />
                </BaseIcon>
              </div>
            </div>
          </BaseFormItem>
        </div>
      </BaseForm>
    </BaseTextContent>
  </BaseDialog>
</template>
<script lang="tsx" setup>
import { ref } from 'vue';
import {
  BaseTextContent,
  BaseForm,
  BaseFormItem,
  BaseDialog,
  BaseUpload,
  BaseIcon,
  BaseImage,
  BaseInput
} from 'xrk-components';

import { DeleteFilled } from '@element-plus/icons-vue';
import { uploadApi } from '@data-source/common/apis';

const props = withDefaults(
  defineProps<{
    remove?: () => {};
    invoiceImgList: Array<any>;
  }>(),
  {}
);

const disabled = true;

const formRef = ref(null);
const formData = ref({
  list: props.invoiceImgList
});

const formRules = {
  imgList: [
    {
      required: true,
      trigger: 'change',
      validator: (rule, v, callback) => {
        if (!v?.length) {
          return callback(new Error('请上传发票'));
        }
        if (v.some(item => !item.invoicePic)) {
          return callback(new Error('请重新上传发票'));
        }
        if (v.some(item => !item.invoiceNo)) {
          return callback(new Error('请填写发票信息'));
        }
        callback();
      }
    }
  ]
};
</script>
